export default __webpack_public_path__ + "static/media/Charlotte Walker.f066959c.jpg";